import React, { createContext, useEffect, useState } from 'react';

export const URLContext = createContext({});
export function URLProvider({children}) {
  const [globalUserID, setGlobalUserID] = useState(null);
  const [globalCampaignID, setGlobalCampaignID] = useState(null);
  const [baseURL, setBaseURL] = useState('./assets/');
  const [dataLoaded, setDataLoaded] = useState();
  const [campaignData, setCampaignData] = useState({
    titleBeforeTicket: "",
    titleAfterTicket: "",
    titleAfterTicketPlural: "",
    subtitleTicket: "",
    noTickets: "",
    afterTicket: "",
    ticketTitle: "",
    balanceTitle: "",
    certificate: "",
    winnerTitle: "",
    winnerText: "",
    loserTitle: "",
    loserText: "",
    imgBanner: "",
    imgHeaderInterna: "",
    imgTicket: "",
    imgWin: "",
    imgLose: "",
    imgError: "ame-erro.svg"
  });

  useEffect(() => {
    let userID = new URLSearchParams(window.location.search).get('id');
    if ( userID !== null || userID !== undefined || userID !== "" ) {
      setGlobalUserID(userID)
    }

    let campaignID = new URLSearchParams(window.location.search).get('campaign');
    if ( campaignID !== null || campaignID !== undefined || campaignID !== "" ) {
      setGlobalCampaignID(campaignID)
    }
  },[]);

  useEffect(() => {
    let mounted = true;

    if( globalCampaignID !== null ) {
      let baseS3 = process.env.REACT_APP_S3 || "https://ame-promocoes.s3.amazonaws.com/assets/";
      setBaseURL( `${baseS3}${globalCampaignID}/` );

      if(mounted) {
        fetch( baseS3 + globalCampaignID + '/data.json' )
        // fetch( './testjson.json' )
          .then( (response) => response.json())
          .then(data => {
            setCampaignData(data);
            setDataLoaded(true);
          })
          .catch((error) => {
            console.log('ERRO', error);
            setDataLoaded(false);
            setBaseURL('./assets/');
          })
      }
    }
    return () => mounted = false;

  }, [globalUserID, globalCampaignID])
  
  return (
    <URLContext.Provider
      value={{
        globalUserID,
        globalCampaignID,
        baseURL,
        campaignData,
        dataLoaded,
        setGlobalUserID,
        setGlobalCampaignID
      }}
    >
      {children}
    </URLContext.Provider>
  )
}